import clsx from "clsx";

import translate from "../../locales";
import Markdown from "react-markdown";

export function InfoDialog({ translationScope, children }) {
  return (
    <div className={clsx("card")}>
      <div className={clsx("card__content")}>
        <div className="card__header">
          <h1 className={clsx("card__title")}>
            {translate([...translationScope, "title"])}
          </h1>
          <p className={clsx("card__subtitle")}>
            {translate([...translationScope, "subtitle"])}
          </p>
        </div>
        <div className="card__message">
          <Markdown>{translate([...translationScope, "message"])}</Markdown>
        </div>
        {children}
      </div>
    </div>
  );
}
